import { VERSION_DATA_EXPIRATION_TIME } from '../config';
import { useState, useEffect } from 'react';

export function checkVersionData(versionData, fetchVersionData) {
    const storedVersionData = sessionStorage.getItem('versionData');
    if (storedVersionData) {
        const parsedData = JSON.parse(storedVersionData);
        const currentTime = Date.now();
        const expirationTime = VERSION_DATA_EXPIRATION_TIME;

        if (parsedData.timestamp && currentTime - parsedData.timestamp < expirationTime) {
            return parsedData.data;
        } else {
            return fetchVersionData(versionData).then(data => {
                sessionStorage.setItem('versionData', JSON.stringify({ data, timestamp: currentTime }));
                return data;
            });
        }
    } else {
        return fetchVersionData(versionData).then(data => {
            sessionStorage.setItem('versionData', JSON.stringify({ data, timestamp: Date.now() }));
            return data;
        });
    }
}

export const usePerservedState = (key, defaultValue, shouldPersist = true) => {
    const [state, setState] = useState(() => {
        if (shouldPersist) {
            const storedValue = localStorage.getItem(key);
            return storedValue ? JSON.parse(storedValue) : defaultValue;
        } else {
            return defaultValue;
        }
    });

    useEffect(() => {
        if (shouldPersist) {
            localStorage.setItem(key, JSON.stringify(state));
        } else {
            localStorage.removeItem(key);
        }
    }, [key, state, shouldPersist]);

    return [state, setState];
};